export const companyAdminRolesDictionary = {
    OWNER: 'Owner',
    FULL_ADMIN: 'Full Admin',
    OFFICE_MANAGER: 'Office Manager',
    VIEWER: 'Viewer',
    BILLS_APPROVER: 'Bills Approver',
    BILLS_PAYER: 'Bills Payer',
};
